import React from "react";
import PropTypes from "prop-types";

import Text from "Components/shared/text";
import styles from "./formControl.module.css";
/**
 *
 * @param {JSX.Element} element A control Element
 * @param {JSX.Element | string} label A control label
 * @returns JSX.Element
 */
const FormControl = ({
  children,
  className,
  element,
  label,
  name,
  id,
  error,
  fullWidth,
  ...props
}) => {
  return (
    <div
      className={`${className} ${styles.root} ${
        fullWidth ? styles.fullWidth : ""
      }`}
      {...props}
    >
      <Text color="primary" variant="sm" tag="label" htmlFor={id}>
        {label}
      </Text>
      {React.cloneElement(element || children, { error, id, name })}
    </div>
  );
};
FormControl.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  element: PropTypes.element,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.string,
  id: PropTypes.string,
  error: PropTypes.string,
  fullWidth: PropTypes.bool,
};
export default FormControl;
